export default __webpack_public_path__ + "static/media/doctors.a4c84051.jpg";